import { useDataProvider } from 'ra-core';
import { useEffect, useRef } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

/**
 * When a "Related Quotation" is picked on a document form (e.g. Proforma
 * Invoice created directly, not via the quotation's Convert button), pull the
 * company / customer / customer_name from the chosen quotation so the user
 * doesn't re-enter them. See bug tracker PI #20.
 */
export const QuotationWatcher = () => {
    const { setValue } = useFormContext();
    const quotationId = useWatch({ name: 'quotation_id' });
    const dataProvider = useDataProvider();
    const lastApplied = useRef<string | number | null>(null);

    useEffect(() => {
        if (!quotationId || lastApplied.current === quotationId) return;

        let cancelled = false;
        const apply = async () => {
            try {
                const { data: q } = await dataProvider.getOne('quotations', { id: quotationId });
                if (cancelled || !q) return;
                lastApplied.current = quotationId;
                if (q.company_id) setValue('company_id', q.company_id, { shouldDirty: true });
                if (q.customer_id) setValue('customer_id', q.customer_id, { shouldDirty: true });
                if (q.customer_name) setValue('customer_name', q.customer_name, { shouldDirty: true });
            } catch (e) {
                console.error('Error fetching quotation for autofill:', e);
            }
        };
        apply();
        return () => {
            cancelled = true;
        };
    }, [quotationId, dataProvider, setValue]);

    return null;
};
